import { gql } from '@apollo/client';

export const ALL_EDUCATOR_LEVELS = gql`
  query getEducatorLevels {
    educatorLevels: getEducatorLevels {
      id
      name
    }
  }
`;
